var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"row pt-3 pb-3 pt-md-5 pb-md-5 h-auto"},[_c('div',{staticClass:"col-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.user.Data.CompanyConfiguration.HomeBannerText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }